require('./javascripts/application.js');
require('./stylesheets/main.scss');
